import { ColHeaderTreeManager } from '../Classes/ColHeaderClasses'

class GridTools {
  processHeaders (headers) {
    if (!headers) return null

    const treeManager = new ColHeaderTreeManager(headers)

    while (!treeManager.allResolved()) {
      treeManager.removeResolved()
      const currentlyActive = Array.from(treeManager.activeNodes)

      for (let i = 0; i < currentlyActive.length; i++) {
        currentlyActive[i].tryResolve()
      }
    }

    return treeManager
  }
}

export default Object.freeze(new GridTools())



// WEBPACK FOOTER //
// ./src/components/report-tables/legacy/Utils/GridTools.js